import { NovastarHSeriesBase } from './util/NovastarHSeriesBase';
export class NovastarHSeriesUdp extends NovastarHSeriesBase {
    constructor(socket, log) {
        super(log);
        this.socket = socket;
        this.log = log;
        this.ipAddress = '';
        this.port = 0;
        this.commandExtractor = {
            terminators: ['\r'],
        };
        this.sendTerminator = '\r';
    }
    onConfigure(config) {
        var _a, _b;
        super.onConfigure(config);
        this.ipAddress = (_a = config.ipAddress) !== null && _a !== void 0 ? _a : '';
        this.port = (_b = config.port) !== null && _b !== void 0 ? _b : 0;
    }
    parser(message) {
        return {
            address: message.address,
            message: message.message,
            port: message.port,
        };
    }
    send(response) {
        this.socket.send(this.ipAddress, this.port, response);
    }
}
NovastarHSeriesUdp.emulatorType = 'udpEmulator';
NovastarHSeriesUdp.key = '-NhSF9pDOGwqfdj2P7mY';
